<template>
  <b-form-group :label="label">
    <b-input-group>
      <b-form-input
        readonly
        @input="$emit('input', $event.target.value)"
        ref="input"
        class="col-sm-2"
        type="text"
        :name="name"
        v-model="item.id"
        placeholder="ID"
        :state="state"
      ></b-form-input>
      <b-form-input
        type="text"
        :name="name + '_desc'"
        v-model="item.label"
        class="col-sm-8"
        :placeholder="placeholder"
        readonly
        :state="state"
      ></b-form-input>
      <b-input-group-append>
        <b-button
          v-if="!readonly"
          variant="success"
          class=""
          @click="doShowModal()"
          >selecionar</b-button
        >
        <b-button v-if="!readonly" variant="danger" class="" @click="clear()"
          ><i class="fa fa-times"></i
        ></b-button>
      </b-input-group-append>
    </b-input-group>
    <b-modal
      no-enforce-focus
      @shown="showModal = true"
      @hidden="showModal = false"
      size="xl"
      ref="selectorModal"
    >
      <component
        v-bind:is="modal"
        :filters="filters"
        v-if="showModal"
        v-on:select-item="itemSelected"
      ></component>
    </b-modal>
  </b-form-group>
</template>

<script>
import Vue from "vue";
import DsrModal from "@/views/dealers/dsr/modal.vue";
import DsrNewModal from "@/views/dealers/dsr-new/modal.vue";
import DealersModal from "@/views/dealers/dealers/modal.vue";
import DealersNewModal from "@/views/dealers/dealers-new/modal.vue";
import ZonesModal from "@/views/dealers/zones/modal.vue";
import OperatorsModal from "@/views/dealers/operators/modal.vue";
import OperatorGroups from "@/views/dealers/operator_groups/modal.vue";
import ProductsModal from "@/views/products/products/modal.vue";
import ProdaggregsModal from "@/views/products/prodaggregs/modal.vue";
import Bestof from "@/views/campaigns/bestof/campaigns/modal.vue";
import IndependentOperators from "@/views/scorecard/independents/operators/modal.vue";

Vue.component("dsr-modal", DsrModal);
Vue.component("dsr-new-modal", DsrNewModal);
Vue.component("dealers-modal", DealersModal);
Vue.component("dealers-new-modal", DealersNewModal);
Vue.component("zones-modal", ZonesModal);
Vue.component("operators-modal", OperatorsModal);
Vue.component("prodaggreg-modal", ProdaggregsModal);
Vue.component("products-modal", ProductsModal);
Vue.component("bestof-modal", Bestof);
Vue.component("operator-groups-modal", OperatorGroups);
Vue.component("independent-operators-modal", IndependentOperators);

export default {
  name: "modal-select",
  $_veeValidate: {
    value() {
      return this.item.id;
    },
    name() {
      return this.name;
    },
  },
  props: [
    "name",
    "state",
    "itemId",
    "itemName",
    "readonly",
    "placeholder",
    "label",
    "modal",
  ],
  data() {
    return {
      filters: null,
      showModal: false,
      item: {
        id: null,
        label: "",
      },
    };
  },
  methods: {
    clear() {
      this.item.id = null;
      this.item.label = null;
      this.$emit("select-item", {
        item: null,
      });
      this.$emit("input", this.item.id);
    },
    itemSelected(e) {
      this.item.id = e.item.id;
      this.item.label = e.item.name;
      console.log("item selected", e.item);
      this.$emit("select-item", {
        item: e.item,
      });
      this.$emit("input", this.item.id);
      this.hideModal();
    },
    doShowModal() {
      this.$refs.selectorModal.show();
    },
    hideModal() {
      this.$refs.selectorModal.hide();
    },
  },
  created() {
    this.item.id = typeof this.itemId == "undefined" ? "" : this.itemId;
    this.item.label = this.itemName;
  },
};
</script>
